module.exports = __webpack_public_path__ + "static/media/quran1.eeca0bd4.jpg";